import React, {useEffect, useState} from 'react'
import {CountingAPI} from '../../../apis/CountingAPI'
import { Card, CardBody, FormControl, FormLabel} from '@chakra-ui/react'
import {RowsMissedTable} from './RowsMissedTable/RowsMissedTable'
import { Switch, Flex } from '@chakra-ui/react'

const RowsMissed = (props) => {
    const {countingId} = props
    const [rowsMissed, setRowsMissed] = useState([])
    const [categories, setCategories] = useState([])
    const [rowsMissedTotal, setRowsMissedTotal] = useState(0)
    const [filters, setFilters] = useState({})
    const [rowMissedCounted, setRowMissedCounted] = useState(false)

    const fetchMissingRows = async (countingId) => {
        // console.log('fetch missing rows', countingId)
           const resp = await (rowMissedCounted
           ? CountingAPI.getMissingRowsCounting(countingId, false, filters)
           : CountingAPI.getMissingRows(countingId, false, filters))
        setRowsMissed(resp.missing_rows ?? [])
        setRowsMissedTotal(resp.missing_rows_total ?? 0)
        !categories.length && setCategories(resp.missing_rows.reduce(
            (acc, {categoryName}) => !acc.length 
                ? ['', categoryName] 
                : (acc.includes(categoryName) ? acc :  [...acc, categoryName]), [])
        )
    }
    useEffect(() => {
        fetchMissingRows(countingId)
    }, [filters, rowMissedCounted, countingId])
    
    return (

        <Card>
            <CardBody>
                <Flex justify='flex-end' mb={4}>
                <FormControl display='flex' alignItems='center' width='auto'>
                    <FormLabel>
                        Missed rows by {rowMissedCounted ? 'Counted Items' : 'Categories'} 
                    </FormLabel>
                    <Switch isChecked={rowMissedCounted} onChange={(e) => setRowMissedCounted(e.target.checked)} colorScheme='green'/>
                </FormControl>
                </Flex>
              <RowsMissedTable 
                rowsMissed={rowsMissed} 
                rowsMissedTotal={rowsMissedTotal} 
                categories={categories} 
                filters={filters} 
                setFilters={setFilters}
              />
            </CardBody>
        </Card>
    )
}

export default RowsMissed